import { useEffect, useState } from "react";

export default function PrintPage() {
  const [data, setData] = useState({});

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("printData"));
    setData(storedData || {});

    setTimeout(() => {
      window.print();
      window.close(); // auto close after print
    }, 500);
  }, []);

  return (
    <div>
      <table style={{ width: '100%', border: '0px solid #805c78', maxWidth: '500px', marginLeft: '20px', border: '0px' }} border="0">
        <thead style={{ height: '160px' }}>
          <tr style={{ height: '50px' }}>
            <td></td>

          </tr>
          <tr>
            <td colspan="3">
              <table>
                <tr>
                  <td style={{ border: '0px', width: '501px', paddingLeft: '90px', fontFamily: 'Roboto' }}>Matrimony Registration</td>
                  <td style={{border:'0px',paddingLeft: '70px',fontFamily:'Roboto'}}>{new Date().toLocaleDateString()}</td>
                </tr>
                <tr>
                  <td style={{ border: '0px', width: '501px', paddingLeft: '90px', fontFamily: 'Roboto' }}> </td>
                  <td style={{ border: '0px', paddingLeft: '70px', fontFamily: 'Roboto' }}>{data.billNo}</td>
                </tr>
              </table>
            </td>
          </tr>

        </thead>
        <tbody>
          <tr>
            <td colspan="4">
              <table border="0" style={{ width: '100%', marginLeft: '30px', height: '150px' }}>
                <tr>
                  <td style={{ width: '25px' }}></td>
                  <td style={{ width: '525px' }}></td>
                  <td style={{ width: '125px' }}></td>
                </tr>
                <tr>
                  <td>1</td>
                  <td style={{ paddingLeft: '20px', fontFamily: 'Roboto', fontFamily: 'Roboto' }}>{data.name}</td>
                  <td style={{ paddingLeft: '30px', fontFamily: 'Roboto', fontFamily: 'Roboto' }}>300.00</td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <table>
                <tr>
                  <td style={{ width: '525px' }}></td>
                  <td style={{ width: '240px', paddingLeft: '300px', height: '10px', fontFamily: 'Roboto' }}>300.00</td>
                </tr>
                <tr></tr>
                <tr style={{height:'60px'}}><td style={{width:'525px'}}></td>
                            <td style={{width:'240px',paddingLeft:'40px',fontFamily:'Roboto',}}>Rupees Three Hundred Only  <br /> <i>(Payment Mode: {data.mode})</i> </td>
                        </tr>
              </table>
            </td>
          </tr>
        </tbody>

      </table>
    </div>

    // <div className="print-container">
    //   <h3 style={{ textAlign: "center" }}>Matrimony Registration</h3>

    //   <p><b>Reg No:</b> {data.regNo}</p>
    //   <p><b>Name:</b> {data.name}</p>
    //   <p><b>Age:</b> {data.age}</p>
    //   <p><b>Height:</b> {data.height}</p>
    //   <p><b>Sex:</b> {data.sex}</p>
    //   <p><b>Caste:</b> {data.caste}</p>
    //   <p><b>Star:</b> {data.star}</p>
    //   <p><b>Dhosham:</b> {data.dhosham}</p>
    //   <p><b>Job:</b> {data.job}</p>
    //   <p><b>Native:</b> {data.native}</p>
    //   <p><b>Phone:</b> {data.phone}</p>
    //   <p><b>Qualification:</b> {data.qualification.join(", ")}</p>
    //   <p><b>Fee:</b> {data.fee}</p>

    //   <button onClick={() => window.print()}>Print</button>
    // </div>
  );
}